<template>
<div style="width: 100%">
  <div>
    <div class="d-flex justify-space-between" style="padding: 22px 16px 21px 16px; color: red; background-color: transparent;">
      <div style="max-height: 100%; background-color: transparent;" class="d-inline-flex align-center">
        <pill-radio-buttons :valuesList="filterPills" @checked="rateValue=$event"/>
      </div>
      <div class="align-content-end align-content-space-between" style="">
            <v-text-field
              rounded
              outlined
              dense
              background-color="white"
              full-width
              v-model="search"
              @input="elasticSearchOnBackend"
              prepend-inner-icon="mdi-magnify"
              :label="$t('feedback_page.search_field')"
              single-line
              hide-details />
      </div>
    </div>
    <v-data-table
      class="round-corner table-style"
      :headers="headers"
      :items="feedbacksDisplayed"
      single-select
      item-key="order_id"
      :sort-by="['date']"
      :sort-desc="[false]"
      :show-select=false
      show-expand
      single-expand
      :expanded.sync="expanded"
      :loading="loading"
      :custom-sort="customSort" 
      :search="search"
      :server-items-length="filteredFeedbacksCount"
      :options.sync="options"
      :page=currentPage
      no-data-text="Keine Rückmeldungen stimmen mit den angegebenen Filtern überein."
      no-results-text="Keine Rückmeldungen stimmen mit den angegebenen Filtern überein."
      :footer-props="{
        itemsPerPageText: $t('feedback_page.per_page') 
      }">
      <template v-slot:[`item.rating`]="{item}">
        <v-rating
          v-model="item.rating"
          :half-increments="true"
          :readonly="true"
        ></v-rating>
      </template>
      <template v-slot:[`item.date`]="{ item }">
        <span>{{ new Date(item.date) | dateFormat('DD.MM.YYYY') }}</span>
      </template>
      <template v-slot:[`item.comment`]="{ item }">
        <v-icon v-if="item.comment">mdi-comment-outline</v-icon>
        <v-icon v-else>mid-comment-outline mdi-inactive mdi-dark mdi-inactive</v-icon>
      </template>
      <template v-slot:[`item.review_agreement`]="{ item }">
        <v-icon v-if="item.review_agreement">mdi-check</v-icon>
        <v-icon v-else>mdi-close mdi-dark mdi-inactive</v-icon>
      </template>
      <template v-slot:expanded-item="{ headers, item}">
        <td :colspan="headers.length">
          <v-row class="expand-pane">
            <v-col>{{item.customer}}</v-col>
            <v-col>{{$t('feedback_page.phone')}} {{item.phone}}</v-col>
            <v-col>{{$t('feedback_page.mail')}} {{item.mail}}</v-col>
          </v-row>
          <v-row class="expand-pane">
            <v-col>{{ item.comment }}</v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>
  </div>
</div>
</template>

<script>
  import PillRadioButtons from '../design-components/PillRadioButtons';
  import { getFeedbacksWithFilter } from '../../services/RatingService';

  export default {
    name: "FeedbackTableComponent",
    components: {
      PillRadioButtons
    },
    data() {
      return {
        expanded: [],
        snackbar: false,
        text: 'Bitte Bestellung und Template auswählen',
        statusText: '',
        activeClass: 'tab-active',
        selectedDevOrder: '',
        dialog: false,
        selectedTemplates: [],
        loading: false,
        filteredFeedbacksCount: 0,
        feedbacksDisplayed: [],
        allFeedbacks: [],
        search: '',
        options: {},
        currentPage: 1,
        itemsPerPage: 10,
        rateValue: 'all',
        headers: [
          {text: this.$t('feedback_page.rating'), value: 'rating' },
          {
            text: this.$t('feedback_page.date'),
            align: 'start',
            sortable: true,
            value: 'date',
          },
          { text: this.$t('feedback_page.zip'), value: 'zip' },
          { text: this.$t('feedback_page.city'), value: 'city' },
          { text: this.$t('feedback_page.product'), value: 'product' },
          { text: this.$t('feedback_page.contact_channel'), value: 'contact_channel' },
          { text: this.$t('feedback_page.agreement'), value: 'review_agreement' },
          { text: this.$t('feedback_page.comment'), value: 'comment'},
          { text: '', value: 'data-table-expand' },
        ],
        headersProd: [
          {
            text: 'Date',
            align: 'start',
            sortable: true,
            value: 'date',
          },
          { text: 'Produkt', value: 'product' },
          { text: 'Besteller', value: 'customer'},
          { text: 'Anschlussadresse', value: 'address'},
          { text: '', value: 'data-table-expand' },
        ],
        filterPills: [
            {label:  this.$t("feedback_page.pill.all"), status: 'all', color: '#999999'},
            {label:  this.$t("feedback_page.pill.comments"), status: 'comments', color: '#f5f5f5'},
            {label:  this.$t("feedback_page.pill.agreement"), status: 'agreement', color: '#f5f5f5'},
         ]
      }
    },
    created(){
      this.$store.commit('setAllFeedbacks',[]);
      this.$store.commit('setNumberOfAllFeedbacks', 0);
      this.$store.commit('setAllFeedbacksLoaded', false)
    },
    computed: {
      order_id() {
        return this.selectedDevOrder;
      },
      allFeedbacksLoaded() {
        return this.$store.getters.getAllFeedbacksLoaded
      }
    },
    watch: {
      options: {
        handler (event) {
          this.currentPage = event.page;
          this.itemsPerPage = event.itemsPerPage;
          this.getFeedbacksWithFilter()
        },
        deep: true,
      },
      rateValue(){
        this.currentPage = 1;
        this.deleteAllLoadedRatings();
        this.getFeedbacksWithFilter();
      }
    },
    methods: {
      customSort: function(items, index, isDesc) {
        items.sort((a, b) => {
          if (index[0]=='date') {
            if (!isDesc[0]) {
                return b[index] - a[index];
            } else {
                return a[index] - b[index];
            }
          }
          else {
            if(typeof a[index] !== 'undefined'){
              if (!isDesc[0]) {
                return a[index].toLowerCase().localeCompare(b[index].toLowerCase());
              }
              else {
                return b[index].toLowerCase().localeCompare(a[index].toLowerCase());
              }
            }
          }
        });
        return items;
      },
      deleteAllLoadedRatings(){
        this.allFeedbacks = [];
        this.feedbacksDisplayed = [];
        this.$store.commit('setAllFeedbacks',[]);
        this.$store.commit('setNumberOfAllFeedbacks', 0);
        this.$store.commit('setAllFeedbacksLoaded', false)
      },
      elasticSearchOnBackend(value){
        if(value.length === 0){
          this.deleteAllLoadedRatings();
          this.getFeedbacksWithFilter();
        }
        else if(value.length > 2){
          this.deleteAllLoadedRatings();
          this.getFeedbacksWithFilter(value);
        }
      },
      getFeedbacksWithFilter(search_word){
        let itemsShowed = false;
        let params = {
          limit: 10, 
          filter: this.rateValue,
          from_index: (this.allFeedbacks) ? this.allFeedbacks.length : 0,
          search_word: search_word ? search_word : this.search
        }
        if(this.allFeedbacks.length === 0){
          this.loading = true;
        }
/*         if (this.allFeedbacksLoaded && this.allFeedbacks.length > (this.currentPage - 1) * this.itemsPerPage && this.itemsPerPage > 0) {
          this.feedbacksDisplayed = this.allFeedbacks.slice((this.currentPage - 1) * this.itemsPerPage, this.currentPage * this.itemsPerPage)
          itemsShowed = true;
        } else if(!this.allFeedbacksLoaded && this.allFeedbacks.length >= this.currentPage * this.itemsPerPage && this.itemsPerPage > 0){
          this.feedbacksDisplayed = this.allFeedbacks.slice((this.currentPage - 1) * this.itemsPerPage, this.currentPage * this.itemsPerPage)
          itemsShowed = true;
        } */
        if(!this.allFeedbacksLoaded && !this.backendLoading){
          this.backendLoading = true;
          getFeedbacksWithFilter(params).then(res => {
            if(res.data.data.getFeedbacksWithFilter) {
              this.filteredFeedbacksCount = res.data.data.getFeedbacksWithFilter.count_feedbacks;
              if(res.data.data.getFeedbacksWithFilter.items.length !== 0){
                this.allFeedbacks = this.allFeedbacks.concat(res.data.data.getFeedbacksWithFilter.items);
                if (this.itemsPerPage > 0 && !itemsShowed) {
                  this.feedbacksDisplayed = this.allFeedbacks.slice((this.currentPage - 1) * this.itemsPerPage, this.currentPage * this.itemsPerPage)
                }
                this.$store.commit('setAllFeedbacks', this.allFeedbacks);
                this.$store.commit('setNumberOfAllFeedbacks', this.allFeedbacks.length);
              }

              let allFeedbacksLoaded = (res.data.data.getFeedbacksWithFilter.items === 0 || this.allFeedbacks.length === this.filteredFeedbacksCount) ? true : false;
              this.$store.commit('setAllFeedbacksLoaded', allFeedbacksLoaded)
              this.backendLoading = false;
            }
/*             if(this.$store.getters.getNumberOfAllFeedbacks < 10 && !this.allFeedbacksLoaded){
              this.getFeedbacksWithFilter(search_word);
            } else {
                      
            } */
            this.loading = false;
          }).catch(err => {
            console.log(err);
          })
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  $main-color: #FFFFFF;
  .tab-font {
    text-align: left;
    font-size: 16px;
    line-height: 18px;
    letter-spacing: 0;
    color: #6E6E6E;
    opacity: 1;
  }

  .tab-style {
    color: #6E6E6E;
    text-transform: none !important;
    margin-bottom: 1px;
    background-color: $main-color;
    opacity: 0.7;
  }

  .tab-active {
    background-color: $main-color;
    margin-bottom: 0;
    opacity: 0.9;
  }

  .tab-item-style {
    background-color: $main-color;
    opacity: 0.9;
    border-radius: 0 12px 0 0;
  }

  .round-top-right-corner {
    border-radius: 0 12px 0 0;
  }

  .round-top-left-corner {
    border-radius: 12px 0 0 0;
  }
  .round-corner {
    border-radius: 12px;
  }
  .table-style {
    background-color: $main-color;
    opacity: 0.9;
  }

.expand-pane {
  margin-left: 48px;
  margin-right: 76px;
}

</style>
